import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { useAppSelector } from "../../app/hooks";
import { selectCurrentUser } from "./usersSlice";
import {
  selectTrayOwnerId,
  setTrayOwner,
  loadTrayEntries
} from "./bulkEndTraySlice";

// SE-1723: keep the bulk-end tray's owner in sync with the logged-in user.
// When the current user changes (login / logout / switch), load THAT user's
// saved tray (or empty) so a tray never carries across accounts. Mount once,
// high in the tree (or on the Users page where the tray is used).
export const useBulkEndTrayHydration = (): void => {
  const dispatch = useDispatch();
  const currentUser = useAppSelector(selectCurrentUser);
  const ownerId = useAppSelector(selectTrayOwnerId);

  useEffect(() => {
    const uid = currentUser?.id ?? null;
    if (uid === ownerId) return;
    dispatch(
      setTrayOwner({ ownerId: uid, entries: uid ? loadTrayEntries(uid) : [] })
    );
  }, [currentUser?.id, ownerId, dispatch]);
};
